import * as angular from "angular";
import {IController} from "angular";
import {PreferencesDialogService} from "../../services/preferences-dialogs-service.service";
import {EmailReportTemplateEnum} from "../../types/email-report-template.enum";
import {SettingsService} from "../../services/settings-service.service";

export class EmailReportConfigurationTabComponent implements IController {

  emailReportConfigurations: any;

  public excludedEmailReportTypes: EmailReportTemplateEnum[];

  constructor(private preferencesDialogService: PreferencesDialogService, private settingsService: SettingsService) {
  }

  $onInit() {
    if (!this.emailReportConfigurations) {
      this.emailReportConfigurations = [];
    }
    this.excludedEmailReportTypes = this.emailReportConfigurations.map(item => item.emailReportType);
  }

  onCreateEmailReportConfiguration() {
    this.preferencesDialogService.createEmailReportConfiguration(this.excludedEmailReportTypes, undefined, true, false)
      .then((emailReportTemplate) => {
        this._createEmailReportConfiguration(emailReportTemplate);
      })
  }

  onEditEmailReportConfiguration(emailReportConfiguration, index) {
    const emailReportConfigurationCopy = angular.copy(emailReportConfiguration);
    this.preferencesDialogService.editEmailReportConfiguration(emailReportConfigurationCopy, this.excludedEmailReportTypes,undefined, true, false)
      .then((emailReportConfiguration) => {
        this._editEmailReportConfiguration(emailReportConfiguration, index);
      })
  }

  onUpdateEmailReportConfiguration(emailReportConfiguration, index) {
    this._editEmailReportConfiguration(emailReportConfiguration, index);
  }

  // onDeleteEmailTemplateConfiguration() {
  //
  // }

  private _createEmailReportConfiguration(emailReportConfiguration) {
    this.settingsService.createEmailReportConfiguration(emailReportConfiguration)
      .then((emailReportConfiguration) => {
        this.emailReportConfigurations.push(emailReportConfiguration);
        this.excludedEmailReportTypes = this.emailReportConfigurations.map(item => item.emailReportType);
      })

  }

  private _editEmailReportConfiguration(emailReportConfiguration, index) {
    this.settingsService.editEmailReportConfiguration(emailReportConfiguration, emailReportConfiguration.emailReportType)
      .then((updatedEmailReportConfiguration) => {
        this.emailReportConfigurations.splice(index, 1, updatedEmailReportConfiguration);
        this.excludedEmailReportTypes = this.emailReportConfigurations.map(item => item.emailReportType);
      })
  }


}

angular
  .module('bringoz.admin.site-preferences')
  .component('emailReportConfigurationTab', {
    bindings: {
      emailReportConfigurations: '<'
    },
    template: require('./email-report-configuration-tab.html').default,
    controller: EmailReportConfigurationTabComponent
  });
